// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GoogleMap{height:-moz-max-content;height:max-content;background:#e5e3df}.GoogleMap .SearchArea{border:1px solid #ddd;border-radius:6px;display:flex}.GoogleMap .SearchArea input{flex:1;outline:none;border:none;height:30px;padding:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
